import React from 'react';

import { flagStyles } from '../settings';

const SvgUM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5496px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgUM;
